import React from "react";
import PageBanner from "../../../components/sections/front/Common/PageBanner";
import BannerImage from "../../../assets/image/image-page-banner.webp";
import OurPartners from "../../../components/sections/front/Common/OurPartners";
import TextBlock from "../../../components/sections/front/Common/TextBlock";
import SectionAnnoucements from "../../../components/sections/front/Updates&Blog/SectionAnnoucements";
import SectionBlogs from "../../../components/sections/front/Updates&Blog/SectionBlogs";
import { useBanner } from "../../../providers/BannerProviders";
import { Helmet } from "react-helmet-async";

const UpdatesAndBlogs = () => {
  const { data } = useBanner();
  const blogsBanner = data?.data?.find(
    (item) => item?.bannerType === "updatesAndBlogs"
  );

  return (
    <>
      {blogsBanner && (
        <Helmet>
          <title>{blogsBanner.seoTitle}</title>
          <meta
            name="description"
            property="og:description"
            content={blogsBanner.seoDescription}
          />
          <meta
            name="keywords"
            property="og:keywords"
            content={blogsBanner.seoKeyword}
          />
          <meta
            name="author"
            property="og:author"
            content={blogsBanner.seoAuthor}
          />
          <meta
            property="og:image"
            content="https://api.vpeters.iosx.in/storage/siteSetting/1744792455206fdfb9210eeb9358cf800c535.jpeg"
          />
          <meta
            property="og:image:url"
            content="https://api.vpeters.iosx.in/storage/siteSetting/1744792455206fdfb9210eeb9358cf800c535.jpeg"
          />
          <meta
            property="og:image:secure_url"
            content="https://api.vpeters.iosx.in/storage/siteSetting/1744792455206fdfb9210eeb9358cf800c535.jpeg"
          />
        </Helmet>
      )}
      <PageBanner title={blogsBanner?.title} image={blogsBanner?.image?.url} />
      <TextBlock
        description={blogsBanner?.contentDescription}
        // action={{ label: "Announcements", isLink: true, link: "/updates" }}
      />
      <SectionAnnoucements />
      <TextBlock
        title={blogsBanner?.details?.blog?.title}
        description={blogsBanner?.details?.blog?.description}
      />
      <SectionBlogs />
      <OurPartners />
    </>
  );
};

export default UpdatesAndBlogs;
